import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  return (
    <header
      style={{
        width: "100%",
        backgroundColor: "#f4f6fb",
        borderBottom: "1px solid #d9dee8",
        padding: "16px 0",
        position: "sticky",
        top: 0,
        zIndex: 1000
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1400px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: "20px",
          paddingRight: "20px"
        }}
      >
        {/* LEFT (Aligned with Hero) */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px"
          }}
        >
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "12px",
              backgroundColor: "#2fb3a6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "22px"
            }}
          >
            🎓
          </div>
          <h2 style={{ margin: 0, fontSize: "20px", color: "#1e2a44" }}>
            LearnHub
          </h2>
        </div>

        {/* CENTER */}
        <div
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "40px"
          }}
        >
          <a href="#features" style={{ textDecoration: "none", color: "#667085" }}>
            機能
          </a>
          <a href="#about" style={{ textDecoration: "none", color: "#667085" }}>
            概要
          </a>
          <a href="#contact" style={{ textDecoration: "none", color: "#667085" }}>
            お問い合わせ
          </a>
        </div>

        {/* RIGHT (pushed slightly more right) */}
        <div style={{ marginRight: "25px" }}>
          <button
  onClick={() => navigate("/login")}
  style={{
    backgroundColor: "#2fb3a6",
    color: "white",
    border: "none",
    borderRadius: "14px",
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer"
  }}
>
  ログイン
</button>
        </div>
      </div>
    </header>
  );
}

export default Navbar;